import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
   private appConfig;
   private httpClient: HttpClient;

   constructor(handler: HttpBackend) {
      this.httpClient = new HttpClient(handler);
   }

   initializeAppFactory(): () => void | Observable<unknown> | Promise<unknown> {
     return () => this.httpClient.get('/assets/configuration.json')
      .pipe(
        tap(config => {
          this.appConfig = config;
          console.log('Application config loaded:', config);
        })
      )
      .toPromise(); // Convert Observable to Promise for APP_INITIALIZER
   }
   //loadAppConfig() {
   //  return this.httpClient.get('/assets/configuration.json').subscribe(
   //    (response) => {
   //      this.appConfig = response;
   //      console.log('Configuration received:', response);
   //    },
   //    (error) => {
   //      console.error('Error fetching configuration:', error);
   //    }
   //  );


        // .toPromise()
        //.then(data => {
        //  console.log('got config', data);
        //    this.appConfig = data;
        //});
   //}

   getConfig() {
      return this.appConfig;
   }
}
